import EventPage from "./components/eventPage";
import AddCategory from "./components/addCateogory";
import AttendeesForm from "./components/attendeesForm";
import Checkout from "./components/checkout";
import CheckoutPc from "./components/checkoutPc";

export {
    EventPage,
    AddCategory,
    AttendeesForm,
    Checkout,
    CheckoutPc,
}